type ValueSelectorFunction<TValue = any> = (value: TValue) => any;

export const getSelectedValue = <TReturn = any, TValue = any>(
  value: TValue,
  selector?: ValueSelectorFunction<TValue>
): TReturn => {
  if (selector) {
    return selector(value);
  }

  return (value as unknown) as TReturn;
};
